import { FC } from 'react';
import { COLORS } from '@/styles/color';

interface StarProps {
  fillPercent: number;
  width?: number;
  height?: number;
  outlined?: boolean;
  color?: string;
  backgroundColor?: string;
}

const Star: FC<StarProps> = ({ fillPercent, ...props }) => {
  const id = `star-gradient-${fillPercent}`;

  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? props.width ?? 23}
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.998 1.73438C14.6628 0.0434101 17.0558 0.0434101 17.7206 1.73438L20.4833 8.76148C20.7673 9.48382 21.4436 9.97662 22.2182 10.0257L29.734 10.5019C31.5388 10.6163 32.2771 12.8769 30.8877 14.0345L25.0637 18.8866C24.4714 19.3802 24.2155 20.1702 24.4059 20.9173L26.2816 28.2745C26.7297 30.032 24.7948 31.4305 23.2666 30.4538L16.9363 26.4081C16.2796 25.9884 15.4389 25.9884 14.7822 26.4081L8.452 30.4538C6.92373 31.4305 4.98888 30.032 5.43695 28.2745L7.31265 20.9173C7.50312 20.1702 7.24719 19.3802 6.65483 18.8866L0.830884 14.0345C-0.558543 12.8769 0.179763 10.6163 1.98459 10.5019L9.50042 10.0257C10.275 9.97662 10.9513 9.48382 11.2353 8.76148L13.998 1.73438Z"
        fill={`url(#${id})`}
        stroke={props.color}
        strokeWidth={props.outlined ? 2 : 0}
      />
      <defs>
        <linearGradient id={id} x1={0} y1={0} x2={32} y2={0} gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFDC72" />
          <stop offset={Math.max(0, Math.min(1, fillPercent))} stopColor="#FFC196" />
          <stop offset={Math.max(0, Math.min(1, fillPercent + 0.0001))} stopColor={props.backgroundColor} />
          <stop offset="1" stopColor={props.backgroundColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

Star.defaultProps = {
  outlined: false,
  color: '#FFDC72',
  backgroundColor: COLORS.GRAY.TINT,
};

export default Star;
